import { AvField } from "availity-reactstrap-validation"
import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"
import { AvForm } from "availity-reactstrap-validation"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import {
    checkClientNumber,
    createLead,
    getBrands,
    getBranches,
    getLeadDetails,
    getModels,
    getUsers,
    getVariants,
    getVehicles,
    updateLead,
    resetLeadDetails,
    resetClientNumber,
    getUsersWithCrossBranch,
} from "store/actions"
import { map } from "lodash"
import { useRole, ROLE_TYPES } from "hooks/useRole"
import ExistingLeadCard from "./ExistingLeadCard"
import {
    useHistory,
    useLocation,
    useParams,
} from "react-router-dom"
import MetaTag from "components/Common/Meta-tag"
import Breadcrumbs from "components/Common/Breadcrumb"
import Spinner from "components/Common/Spinner"
import { CountryCode } from "constants/countryValues"

// Medium options constant
const MEDIUM_OPTIONS = [
    { label: "Social", value: "social" },
    { label: "Walk-In", value: "direct" },
    { label: "Call", value: "call" },
    { label: "Website", value: "website" },
    { label: "OLX", value: "olx" },
]

export const LEAD_CONDITION = {
    SUPER_HOT: 'superHot',
    HOT: 'hot',
    WARM: 'warm',
    NORMAL: 'normal',
}


function LeadFormPage() {
    const dispatch = useDispatch()
    const params = useParams()
    const history = useHistory()
    const location = useLocation()
    const { isRole, isAnyRole, currentRole } = useRole()

    // Determine if this is update mode
    const isUpdateMode = Boolean(params?.id)
    const leadTypeValue = location?.search?.split("=")[1] // sales or purchase

    // Redux selectors
    const { LeadDetails, loading, allVehicle, members, brand, model, varient, clientNumber, branches, user } =
        useSelector(state => ({
            LeadDetails: state.Lead.leadDetails,
            loading: state?.Lead?.loading,
            allVehicle: state.Vehicle.vehicles?.vehicles,
            members: state?.Members.users?.users,
            brand: state.Brand.brands?.brands,
            model: state.Model.models?.models,
            varient: state.Varient.variants?.variants,
            clientNumber: state.Lead?.clientNumber,
            branches: state.Branches?.branches?.branches,
            user: state.Login.user,
        }))

    // Vehicle states
    const [vehicle, setVehicle] = useState("Select Vehicle...")
    const [vehicleId, setVehicleId] = useState("")
    const [vehicleSearch, setVehicleSearch] = useState("")

    // Client states
    const [client, setClient] = useState("Select Client...")
    const [clientId, setClientId] = useState("")

    // Type states
    const [type, setType] = useState("Select...")
    const [typeValue, setTypeValue] = useState("")

    // Medium states
    const [medium, setMedium] = useState("Select...")
    const [mediumValue, setMediumValue] = useState("")

    // Lead Condition states
    const [leadConditionValue, setLeadConditionValue] = useState("")

    // Member/Assignee states
    const [member, setMember] = useState("Select member...")
    const [memberId, setMemberId] = useState("")
    const [memberSearch, setMemberSearch] = useState("")
    const [assigneeBranch, setAssigneeBranch] = useState(null)

    // Brand states
    const [brandValue, setBrandValue] = useState("Select Brand...")
    const [brandId, setBrandId] = useState("")
    const [brandSearch, setBrandSearch] = useState("")

    // Model states
    const [modelValue, setModelValue] = useState("Select Model...")
    const [modelId, setModelValueId] = useState("")
    const [modelSearch, setModelSearch] = useState("")

    // Variant states
    const [varientValue, setVarientValue] = useState("Select Variant...")
    const [varientId, setVarientId] = useState("")
    const [varientSearch, setVarientSearch] = useState("")

    // Branch state
    const [branchId, setBranchId] = useState("")
    const [branchLabel, setBranchLabel] = useState("Select Branch...")
    const [branchSearch, setBranchSearch] = useState("")

    // Country Code states
    const defaultCountryCode = { label: "+91 (India)", value: "+91" }
    const [countryCode, setCountryCode] = useState(defaultCountryCode)

    const countryCodeOptions = CountryCode.map(c => ({
        label: `${c.code} (${c.name})`,
        value: c.code,
    }))

    // Assignee dropdown visibility
    const [showAssigneeDropdown, setShowAssigneeDropdown] = useState(false)

    // Fetch lead details if in update mode
    useEffect(() => {
        if (isUpdateMode) {
            dispatch(getLeadDetails(params?.id))
        } else {
            dispatch(resetLeadDetails())
            dispatch(resetClientNumber())
        }
    }, [dispatch, params?.id, isUpdateMode])

    // Phone number check
    const handleVehicleNumber = value => {
        dispatch(checkClientNumber({ phone: value, countryCode: countryCode?.value || "+91" }))
    }


    // Fetch users/members
    useEffect(() => {
        const isAdminUser = isRole(ROLE_TYPES.ADMIN) || isRole(ROLE_TYPES.BRANCH_MANAGER)

        if (isAdminUser) {
            dispatch(getUsersWithCrossBranch("", "", memberSearch, '', "", "", ""))
        } else {
            dispatch(getUsers("", "", memberSearch, '', "", "", ""))
        }
    }, [dispatch, memberSearch])

    // Fetch vehicles
    useEffect(() => {
        dispatch(getVehicles("", "", vehicleSearch, "", "", "", "", "", "", "", "", false))
    }, [dispatch, vehicleSearch])

    // Fetch brands
    useEffect(() => {
        dispatch(getBrands("", "", "", brandSearch))
    }, [dispatch, brandSearch])

    // Fetch models
    useEffect(() => {
        dispatch(getModels("", "", modelSearch, brandId))
    }, [dispatch, modelSearch, brandId])

    // Fetch variants
    useEffect(() => {
        dispatch(getVariants("", "", varientSearch, ""))
    }, [dispatch, varientSearch])

    // Fetch branches
    useEffect(() => {
        if (isRole(ROLE_TYPES.SUPER_ADMIN)) {
            dispatch(getBranches("", "", branchSearch, "", ""))
        }
    }, [dispatch, branchSearch])

    // Set member from update data
    useEffect(() => {
        if (isUpdateMode && LeadDetails) {
            setMemberId(LeadDetails?.assignee?._id)
            setMember(LeadDetails?.assignee?.name)
        }
    }, [LeadDetails, isUpdateMode])

    // Set client from update data
    useEffect(() => {
        if (isUpdateMode && LeadDetails) {
            setClientId(LeadDetails?.client?._id)
            setClient(LeadDetails?.client?.name)

            if (LeadDetails?.client?.countryCode || LeadDetails?.countryCode) {
                const code = LeadDetails?.client?.countryCode || LeadDetails?.countryCode
                const match = CountryCode.find(c => c.code === code)
                if (match) {
                    setCountryCode({ label: `${match.code} (${match.name})`, value: match.code })
                }
            }
        }
    }, [LeadDetails, isUpdateMode])

    // Set medium from update data
    useEffect(() => {
        if (isUpdateMode && LeadDetails) {
            setMedium(LeadDetails?.medium)
            setMediumValue(LeadDetails?.medium)
        }
    }, [LeadDetails, isUpdateMode])

    // Set leadCondition from update data
    useEffect(() => {
        if (isUpdateMode && LeadDetails) {
            setLeadConditionValue(LeadDetails?.leadCondition)
        }
    }, [LeadDetails, isUpdateMode])


    // Set Type based on leadTypeValue from URL (create mode only)
    useEffect(() => {
        if (leadTypeValue === "Sales" || (isUpdateMode && LeadDetails?.leadType === "sales")) {
            setType("sales")
            setTypeValue("sales")
        } else {
            setType("purchase")
            setTypeValue("purchase")
        }
    }, [leadTypeValue, LeadDetails, isUpdateMode])

    // Set vehicle from update data
    useEffect(() => {
        if (isUpdateMode && LeadDetails) {
            setVehicle(LeadDetails?.vehicle?.name)
            setVehicleId(LeadDetails?.vehicle?._id)
        }
    }, [LeadDetails, isUpdateMode])


    // Set brand/model/variant from update data
    useEffect(() => {
        if (isUpdateMode && LeadDetails?.brand) {
            setBrandId(LeadDetails?.brand?.id)
            setBrandValue(LeadDetails?.brand?.name)
            setModelValueId(LeadDetails?.model?.id)
            setModelValue(LeadDetails?.model?.name)
            setVarientId(LeadDetails?.varient?.id)
            setVarientValue(LeadDetails?.varient?.name)
        }
    }, [LeadDetails, isUpdateMode])

    // Set branch from update data
    useEffect(() => {
        if (isUpdateMode && LeadDetails) {
            setBranchId(LeadDetails?.branch?._id)
            if (LeadDetails?.branch) {
                setAssigneeBranch(LeadDetails?.branch)
                setBranchLabel(LeadDetails?.branch?.name)
            }
        }
    }, [LeadDetails, isUpdateMode])

    // Close assignee dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showAssigneeDropdown && !event.target.closest('.assignee-dropdown-container')) {
                setShowAssigneeDropdown(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [showAssigneeDropdown])

    // Member options
    const memberOptions = [
        {
            options: members?.map((result, index) => ({
                key: index,
                label: result?.name,
                value: result?._id,
                branch: result?.branch,
                branchName: result?.branch?.branch_name || result?.branch?.name
            })),
        },
    ]

    // Vehicle options
    const vehicleOptions = [
        {
            options: allVehicle?.map((result, index) => ({
                key: index,
                label: result?.name,
                value: result?._id,
            })),
        },
    ]

    // Brand options
    const brandOptions = [
        {
            label: "All",
            value: "",
        },
        {
            options: (brand?.length >= 1 ? brand : [])?.map((results, index) => ({
                key: index,
                label: results.name,
                value: results._id,
            })),
        },
    ]

    // Model options
    const modelOptions = [
        {
            label: "All",
            value: "",
        },
        {
            options: (model?.length >= 1 ? model : [])?.map((results, index) => ({
                key: index,
                label: results.name,
                value: results._id,
            })),
        },
    ]

    // Variant options
    const varientOptions = [
        {
            label: "All",
            value: "",
        },
        {
            options: (varient?.length >= 1 ? varient : [])?.map((results, index) => ({
                key: index,
                label: results?.name,
                value: results?._id,
            })),
        },
    ]

    // Branch options
    const branchOptions = [
        {
            options: (branches?.length >= 1 ? branches : [])?.map((results, index) => ({
                key: index,
                label: results?.branch_name,
                value: results?._id,
            })),
        },
    ]

    // Handlers
    const handlerMemberFinalValue = event => {
        setMember(event.label)
        setMemberId(event.value)
        if (event.branch && event.branch._id) {
            setAssigneeBranch(event.branch)
            setBranchId(event.branch._id)
        } else {
            setAssigneeBranch(null)
            setBranchId("")
        }
    }

    const handlerVehicleFinalValue = event => {
        setVehicle(event?.label)
        setVehicleId(event?.value)
    }

    const handlerFinalValuesBrand = event => {
        setBrandValue(event.label)
        setBrandId(event.value)
    }

    const handlerFinalValueModel = event => {
        setModelValue(event.label)
        setModelValueId(event.value)
    }

    const handleFinalValuesVarient = event => {
        setVarientValue(event.label)
        setVarientId(event.value)
    }

    const handlerBranchFinalValue = event => {
        setBranchLabel(event.label)
        setBranchId(event.value)
    }

    // Form submit handler
    const handleValidSubmit = (e, v) => {
        const leadData = {
            ...v,
            countryCode: countryCode?.value || "+91",
        }

        if (clientId) leadData.client = clientId
        if (mediumValue) leadData.medium = mediumValue
        if (leadConditionValue) leadData.leadCondition = leadConditionValue
        if (typeValue) leadData.leadType = typeValue
        if (vehicleId) leadData.vehicle = vehicleId
        if (memberId) leadData.assignee = memberId

        // For branch: if branchId is set via dropdown or assignee, use it
        // If not set but user is ADMIN and lead has no branch, use admin's branch
        if (branchId) {
            leadData.branch = branchId
        } else if (isUpdateMode && !LeadDetails?.branch && isRole(ROLE_TYPES.ADMIN) && user?.branch?._id) {
            leadData.branch = user.branch._id
        }

        if (typeValue === "dream_car" || typeValue === "purchase") {
            leadData.requestedVehicle = {
                model: String(modelId),
                varient: String(varientId),
                brand: String(brandId),
            }
        }
        if (isUpdateMode) {
            dispatch(updateLead(leadData, params?.id, history))
        } else {
            dispatch(createLead(leadData, history))
        }
    }

    return (
        <div>
            <MetaTag title={isUpdateMode ? "Update Lead" : "Create Lead"} />

            <div className="page-content">
                <Breadcrumbs
                    title="Dashboard"
                    breadcrumbItem={isUpdateMode ? "Update Lead" : "Create Lead"}
                />
                <Container fluid>
                    <div className="container-fluid">
                        <AvForm
                            className="form-horizontal"
                            onValidSubmit={(e, v) => handleValidSubmit(e, v)}
                        >
                            <Row>
                                <Col md={6} xl={5} lg={6} sm={12}>
                                    <Card>
                                        <CardBody>
                                            {/* Phone */}
                                            <div className="mb-3">
                                                <label>
                                                    Phone<span className="text-danger">*</span>
                                                </label>
                                                <div 
                                                    className="d-flex align-items-center border rounded-2 bg-white" 
                                                    style={{ 
                                                        borderColor: "#ced4da",
                                                        transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
                                                    }}
                                                >
                                                    <div style={{ width: "150px" }}>
                                                        <Select
                                                            value={countryCode}
                                                            onChange={setCountryCode}
                                                            options={countryCodeOptions}
                                                            isDisabled={isUpdateMode}
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                control: (provided) => ({
                                                                    ...provided,
                                                                    border: "none",
                                                                    boxShadow: "none",
                                                                    backgroundColor: "transparent",
                                                                    minHeight: "36px",
                                                                }),
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                indicatorSeparator: () => ({ display: "none" }),
                                                                dropdownIndicator: (provided) => ({
                                                                    ...provided,
                                                                    color: "#343a40",
                                                                    padding: "0 8px"
                                                                }),
                                                                valueContainer: (provided) => ({
                                                                    ...provided,
                                                                    padding: "0 12px"
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                    <div style={{ borderLeft: "1px solid #ced4da", height: "20px" }}></div>
                                                    <div className="flex-grow-1">
                                                        <AvField
                                                            name="phone"
                                                            type="number"
                                                            className="form-control border-0 bg-transparent mb-0"
                                                            placeholder="Enter Phone Number"
                                                            disabled={isUpdateMode}
                                                            value={isUpdateMode ? LeadDetails?.client?.phone : ""}
                                                            style={{ boxShadow: "none", height: "36px" }}
                                                            validate={{
                                                                required: {
                                                                    value: true,
                                                                    errorMessage: "Please enter a Phone Number",
                                                                },
                                                            }}
                                                            onChange={e => handleVehicleNumber(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Name */}
                                            <div className="mb-3">
                                                <label>Name</label>
                                                <AvField
                                                    name="name"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Name"
                                                    value={
                                                        isUpdateMode
                                                            ? LeadDetails?.client?.name
                                                            : clientNumber?.clientNumber?.name || ""
                                                    }
                                                    validate={{
                                                        required: {
                                                            value: false,
                                                            errorMessage: "Please enter a Name",
                                                        },
                                                    }}
                                                />
                                            </div>

                                            {/* Assignee - Only show when not updating and not sales executive */}
                                            {!isUpdateMode && !isRole(ROLE_TYPES.SALES_EXECUTIVE) && (
                                                <div className="mb-3 assignee-dropdown-container">
                                                    <div
                                                        className="p-2 px-3 rounded cursor-pointer position-relative"
                                                        style={{ backgroundColor: "#fff8e6", border: "1px solid #f0e68c" }}
                                                        onClick={() => setShowAssigneeDropdown(!showAssigneeDropdown)}
                                                    >
                                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                                            <span className="text-muted" style={{ fontSize: "11px" }}>🕵🏻‍♂️  Assignee</span>
                                                            <i className={`bx ${showAssigneeDropdown ? 'bx-chevron-up' : 'bx-chevron-down'} text-warning`} style={{ fontSize: "18px" }} />
                                                        </div>
                                                        <p className="m-0 fw-medium text-dark" style={{ fontSize: "13px" }}>
                                                            {member || "Not Assigned"}
                                                        </p>

                                                        {/* Dropdown List */}
                                                        {showAssigneeDropdown && (
                                                            <div
                                                                className="position-absolute bg-white shadow-sm rounded mt-2"
                                                                style={{
                                                                    top: "100%",
                                                                    left: 0,
                                                                    right: 0,
                                                                    zIndex: 1000,
                                                                    maxHeight: "200px",
                                                                    overflowY: "auto",
                                                                    border: "1px solid #e0e0e0"
                                                                }}
                                                            >
                                                                {/* Search Input */}
                                                                <div className="p-2 border-bottom">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Search assignee..."
                                                                        value={memberSearch}
                                                                        onChange={(e) => setMemberSearch(e.target.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    />
                                                                </div>

                                                                {/* Options List */}
                                                                <div>
                                                                    {loading ? (
                                                                        <div className="p-3 text-center text-muted">
                                                                            <i className="bx bx-loader bx-spin"></i> Loading...
                                                                        </div>
                                                                    ) : memberOptions[0]?.options?.length > 0 ? (
                                                                        memberOptions[0].options.map((option) => (
                                                                            <div
                                                                                key={option.key}
                                                                                className="p-2 px-3 cursor-pointer"
                                                                                style={{
                                                                                    fontSize: "13px",
                                                                                    transition: "background-color 0.2s",
                                                                                    backgroundColor: memberId === option.value ? "#fff8e6" : "transparent"
                                                                                }}
                                                                                onMouseEnter={(e) => e.target.style.backgroundColor = "#f8f9fa"}
                                                                                onMouseLeave={(e) => e.target.style.backgroundColor = memberId === option.value ? "#fff8e6" : "transparent"}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation()
                                                                                    handlerMemberFinalValue(option)
                                                                                    setShowAssigneeDropdown(false)
                                                                                }}
                                                                            >
                                                                                <span className="fw-medium">{option.label}</span>
                                                                                {option.branchName && (
                                                                                    <span className="text-muted ms-2" style={{ fontSize: "11px" }}>
                                                                                        {option.branchName}
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <div className="p-3 text-center text-muted" style={{ fontSize: "12px" }}>
                                                                            No assignees found
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {assigneeBranch && (
                                                        <div className="mb-3">
                                                            <small className="text-muted mt-1 d-block">
                                                                <i className="bx bx-building-house me-1"></i>
                                                                Branch: <strong>{assigneeBranch.branch_name}</strong>
                                                            </small>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {/* Branch - Only show for SUPER_ADMIN when lead has no branch */}
                                            {(!LeadDetails?.branch && isRole(ROLE_TYPES.SUPER_ADMIN)) && (
                                                <div className="mb-3">
                                                    <label>Branch</label>
                                                    <Select
                                                        onInputChange={text => setBranchSearch(text)}
                                                        value={{ label: branchLabel, value: branchId }}
                                                        placeholder={branchLabel}
                                                        onChange={handlerBranchFinalValue}
                                                        options={branchOptions}
                                                        classNamePrefix="select2-selection"
                                                        isLoading={loading}
                                                    />
                                                </div>
                                            )}

                                            <div className="mb-3">
                                                <label>Medium</label>
                                                <div
                                                    className="btn-group mt-0 mt-xl-0 d-flex align-items-center justify-content-start flex-wrap"
                                                    role="group"
                                                    aria-label="Basic radio toggle button group"
                                                >
                                                    {map(MEDIUM_OPTIONS, (item, key) => (
                                                        <div key={key} className="me-2 mb-2">
                                                            <input
                                                                type="radio"
                                                                className="btn-check"
                                                                name="btnradio-medium"
                                                                id={item.value + "medium"}
                                                                autoComplete="off"
                                                                checked={mediumValue === item.value}
                                                                value={item.value}
                                                                onChange={e => setMediumValue(e.target.value)}
                                                            />
                                                            <label
                                                                className="btn btn-outline-warning"
                                                                htmlFor={item.value + "medium"}
                                                            >
                                                                {item.label}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Lead Condition */}
                                            <div className="mb-3">
                                                <label>Lead Condition</label>
                                                <div
                                                    className="btn-group mt-0 mt-xl-0 d-flex align-items-center justify-content-start flex-wrap"
                                                    role="group"
                                                    aria-label="Basic radio toggle button group"
                                                >
                                                    {map(LEAD_CONDITION, (value, key) => (
                                                        <div key={key} className="me-2 mb-2">
                                                            <input
                                                                type="radio"
                                                                className="btn-check"
                                                                name="btnradio-leadCondition"
                                                                id={value + "leadCondition"}
                                                                autoComplete="off"
                                                                checked={leadConditionValue === value}
                                                                value={value}
                                                                onChange={e => setLeadConditionValue(e.target.value)}
                                                            />
                                                            <label
                                                                className="btn btn-outline-warning"
                                                                htmlFor={value + "leadCondition"}
                                                            >
                                                                {key.split('_').map(w => w.charAt(0) + w.slice(1).toLowerCase()).join(' ')}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Vehicle - Only show if leadTypeValue is "Sales" */}
                                            {(leadTypeValue === "Sales" || (isUpdateMode && LeadDetails?.leadType === "sales")) ? (
                                                <div className="mb-3">
                                                    <label>Vehicle</label>
                                                    <Select
                                                        onInputChange={text => setVehicleSearch(text)}
                                                        value={vehicle}
                                                        placeholder={vehicle}
                                                        onChange={handlerVehicleFinalValue}
                                                        options={vehicleOptions}
                                                        classNamePrefix="select2-selection"
                                                        isLoading={loading}
                                                    />
                                                </div>
                                            ) :
                                                <>
                                                    <div className="mb-3">
                                                        <label>Brand</label>
                                                        <Select
                                                            onInputChange={text => setBrandSearch(text)}
                                                            value={brandValue}
                                                            placeholder={brandValue}
                                                            onChange={handlerFinalValuesBrand}
                                                            options={brandOptions}
                                                            classNamePrefix="select2-selection"
                                                            isLoading={loading}
                                                        />
                                                    </div>

                                                    <div className="mb-3">
                                                        <label>Model</label>
                                                        <Select
                                                            onInputChange={text => setModelSearch(text)}
                                                            value={modelValue}
                                                            placeholder={modelValue}
                                                            onChange={handlerFinalValueModel}
                                                            options={modelOptions}
                                                            classNamePrefix="select2-selection"
                                                            isLoading={loading}
                                                        />
                                                    </div>

                                                    <div className="mb-3">
                                                        <label>Variant</label>
                                                        <Select
                                                            onInputChange={text => setVarientSearch(text)}
                                                            value={varientValue}
                                                            placeholder={varientValue}
                                                            onChange={handleFinalValuesVarient}
                                                            options={varientOptions}
                                                            classNamePrefix="select2-selection"
                                                            isLoading={loading}
                                                        />
                                                    </div>
                                                </>}

                                            {/* Message */}
                                            <div className="mb-3">
                                                <AvField
                                                    style={{ minHeight: 100 }}
                                                    name="message"
                                                    className="form-control"
                                                    type="textarea"
                                                    label="Message"
                                                    value={isUpdateMode ? LeadDetails?.message : ""}
                                                />
                                            </div>

                                            {/* Remarks - Only show when updating */}
                                            {isUpdateMode && (
                                                <div className="mb-3">
                                                    <AvField
                                                        style={{ minHeight: 100 }}
                                                        name="remarks"
                                                        className="form-control"
                                                        type="textarea"
                                                        label="Remarks"
                                                        value={LeadDetails?.remarks ?? ""}
                                                    />
                                                </div>
                                            )}

                                            <div className="py-3 d-flex aling-items-center justify-content-end">
                                                {isUpdateMode ? (
                                                    <Button color="warning" type="submit" className="px-5">
                                                        {loading && <Spinner />} Update
                                                    </Button>

                                                ) : (
                                                    <Button
                                                        color="warning"
                                                        type="submit"
                                                        className="px-5"
                                                        disabled={loading || (clientNumber?.clientNumber?.existingLead && !isRole(ROLE_TYPES.ADMIN) && !isRole(ROLE_TYPES.SUPER_ADMIN))}
                                                    >
                                                        {loading && <Spinner />} Create
                                                    </Button>
                                                )}
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>

                                {/* Show existing lead if client number check found one */}
                                {(!isUpdateMode && clientNumber?.clientNumber?.existingLead) && (
                                    <Col md={6} xl={5} lg={6} sm={12} className="d-flex align-items-stretch">
                                        <ExistingLeadCard 
                                            leadData={clientNumber.clientNumber.existingLead}
                                            clientName={clientNumber.clientNumber.name}
                                            clientPhone={clientNumber.clientNumber.phone}
                                            clientCountryCode={clientNumber.clientNumber.phoneCountryCode || clientNumber.clientNumber.countryCode}
                                        />
                                    </Col>
                                )}
                            </Row>
                        </AvForm>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default LeadFormPage
